import { Heading, TableHead, TableHeader, TableHeaderSelectAll, TableRow } from '@ksyos/design-system';
import styled from 'styled-components';
import { getSelectedLanguage } from '@frontend/translate';

type FinancingFlexTableHeaderProps = {
    allItemsSelected: boolean;
    hasItemsSelected: boolean;
    onSelectAll: (value: boolean) => void;
};

export function FinancingFlexTableHeader({
    allItemsSelected,
    hasItemsSelected,
    onSelectAll,
}: FinancingFlexTableHeaderProps) {
    const language = getSelectedLanguage();

    return (
        <TableHead>
            <TableRow>
                <TableHeader
                    colSpan={5}
                    itemScope
                >
                    <Heading size="medium">{language.request.processDetails}</Heading>
                </TableHeader>
                <TableHeader colSpan={11}>
                    <Heading size="medium">{language.finance.financingDetails}</Heading>
                </TableHeader>
            </TableRow>
            <StyledTableRow>
                <TableHeaderSelectAll
                    checked={hasItemsSelected || allItemsSelected}
                    indeterminate={!allItemsSelected}
                    onSelect={(event) => onSelectAll((event.target as HTMLInputElement).checked)}
                />
                <TableHeader>{language.common.processNumber}</TableHeader>
                <TableHeader>{language.common.creationDate}</TableHeader>
                <TableHeader>{language.service.service}</TableHeader>
                <TableHeader>{language.addCarePathSettingsHeaders.activities}</TableHeader>
                <TableHeader>{language.activity.performedDate}</TableHeader>
                <TableHeader>{language.insurers.careProductType}</TableHeader>
                <TableHeader>{language.activity.activityCode}</TableHeader>
                <TableHeader>{language.organization.organization}</TableHeader>
                <TableHeader>{language.groups.group}</TableHeader>
                <TableHeader>{language.organization.relationNumberAbbeviation}</TableHeader>
                <TableHeader>{language.finance.amount}</TableHeader>
                <TableHeader>{'TB'}</TableHeader>
                <TableHeader>{language.finance.runNumberShort}</TableHeader>
                <TableHeader>{language.request.reasonNoInvoiceOrDeclarationAbbreviation}</TableHeader>
                <TableHeader>{language.request.fundingError}</TableHeader>
                <TableHeader>{language.request.fundingErrorInformationAbbreviation}</TableHeader>
            </StyledTableRow>
        </TableHead>
    );
}

const StyledTableRow = styled(TableRow)`
    background-color: ${({ theme }) => theme.colors.neutral100};
`;
